import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../styles/common';

function WorkoutTitle() {
  return (
    <Container>
      <p>Record your exercise today!</p>
    </Container>
  )
}

export default WorkoutTitle;

const Container = styled.div`
  width: 100%;
  margin-bottom: 50px;
  text-align: center;
  font-size: ${Text.MD};
`